import PropTypes from 'prop-types';
import React, { Component } from 'react';
import 'js/../stylesheets/user/mentions_settings.scss';
import { AddNameForm } from './add_name_form';

export class PrimaryNameDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: 'collapsed',
      errors: false,
      firstName: this.props.initialFirstName,
      middleName: this.props.initialMiddleName,
      lastName: this.props.initialLastName,
    };
  }

  render() {
    switch (this.state.form) {
      case 'collapsed':
        return this.renderDisplayName();
      case 'expanded':
        return this.renderNameInput();
    }
  }

  renderNameInput() {
    return (
      <div className="row col-xs-12 u-ph0x u-mh0x u-ph0x u-mh0x u-mt2x">
        <AddNameForm
          onCancel={this.collapse}
          onAdd={this.updateDisplayName.bind(this)}
          onClearAddNameErrors={this.clearAddNameErrors}
          buttonText="UPDATE NAME"
          errorMessage={this.state.errors}
          middleInitials={true}
          initialFirstName={this.state.firstName}
          initialMiddleName={this.state.middleName}
          initialLastName={this.state.lastName}
          modalMode={this.props.modalMode}
        />
      </div>
    );
  }

  renderDisplayName() {
    return (
      <div className="DesignSystem">
        <div className="row col-xs-12 u-mt2x">
          <div className="TextInput TextInput--md auto-width u-bgColorWhite u-ph0x">
            <div className="u-floatLeft display-name-box u-fw500 u-fs16 u-lineHeight1 u-tcGrayDarkest">
              {this.displayName()}
              <img
                src={$image_url('icons/edit-s18.svg')}
                className="u-clickable add-name-icon u-ml2x"
                onClick={this.expand}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  displayName = () => {
    return [
      this.state.firstName,
      this.state.middleName,
      this.state.lastName,
    ].join(' ');
  };

  expand = () => {
    this.setState({ form: 'expanded', errors: false });
  };

  collapse = () => {
    this.setState({ form: 'collapsed' });
  };

  clearAddNameErrors = () => {
    this.props.onClearAddNameErrors();
    this.setState({ errors: false });
  };

  updateDisplayName(firstName, middleName, lastName) {
    $.ajax({
      url: $r.api_v0_profiles_update_name_path({ subdomain_param: 'api' }),
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify({
        first_name: firstName,
        middle_initials: middleName,
        last_name: lastName,
      }),
    })
      .done((response) => {
        const updateNameState = (firstName, middleName, lastName) => {
          this.props.updateDisplayNameCallback(firstName, middleName, lastName);
          this.setState({
            form: 'collapsed',
            errors: false,
            firstName,
            middleName,
            lastName,
          });
        };
        // The backend applies non-trivial processing to the display name
        // so use what was actually recorded by (in AJAX request response)
        updateNameState(
          response.first_name,
          response.middle_initials,
          response.last_name,
        );
      })
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .fail((xhr) => {
        this.setState({
          errors:
            'We were unable to update your primary name, please try again.',
        });
      });
  }
}
PrimaryNameDisplay.propTypes = {
  initialFirstName: PropTypes.string.isRequired,
  initialMiddleName: PropTypes.string,
  initialLastName: PropTypes.string.isRequired,
  onClearAddNameErrors: PropTypes.func.isRequired,
  updateDisplayNameCallback: PropTypes.func,
  modalMode: PropTypes.bool,
};
PrimaryNameDisplay.defaultProps = {
  modalMode: false,
};

export default PrimaryNameDisplay;
